import { render, staticRenderFns } from "./ClientVenues.vue?vue&type=template&id=25a5ac00&"
import script from "./ClientVenues.vue?vue&type=script&lang=js&"
export * from "./ClientVenues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports